import styled from 'styled-components';
import { companyColor, spacing } from 'styles/theme';

export const ButtonGroup = styled.div`
  display: flex;
  justify-items: space-between;
  gap: 1rem;

  @media (max-width: 600px) {
    flex-direction: column-reverse;
    gap: 0.75rem;
  }
`;

export const Text = styled.p`
  color: ${companyColor('font')};
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media (max-width: 600px) {
    gap: 0.75rem;
  }
`;

export const CcSurchargeNotice = styled.div`
  margin: ${spacing('extraSmall')} 0;
`;

export const TipSummary = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('extraSmall')};
  margin: ${spacing('extraSmall')} 0;
`;

export const SummaryAmount = styled.span`
  color: ${companyColor('font')};
  font-weight: 500;
`;
